module.exports = __webpack_public_path__ + "static/blue-forest-logo-7f97d0cc1e041c0d35e45198c872fd9f.png";